import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CreateForumConvo } from './CreateForumConvo';

interface CreateForumConvoModalProps {
  buttonLabel?: string;
  forumType: string;
  forumKey: string;
  institutionId: number;
}

export const CreateForumConvoModal = (props: CreateForumConvoModalProps) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      <Button variant="primary" size="sm" onClick={() => setShowModal(true)}>
        {props.buttonLabel || 'Create a new Conversation'}
      </Button>
      {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          aria-labelledby="ref-value-picker-modal-title"
          size="xl"
          fullscreen="xl-down"
        >
          <Modal.Header closeButton>
            <Modal.Title id="ref-value-picker-modal-title">Create a new Conversation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CreateForumConvo {...props} onSent={() => setShowModal(false)} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
